import { Immutable } from "immer";
import React from "react";
import { RetailStore } from "tsi-common-react/src/models/location";
import { fetchJson } from "tsi-common-react/src/utils/ajax";

import { LocatorSendSingleStoreModal } from "../LocatorSendSingleStore_Modal";
import { LocatorSurveyModal } from "../LocatorSurveyModal";
import { EmailSendStorePostData } from "../models";
import { buildStoreData } from "../utils";

type IProps = Immutable<{
    store: RetailStore;
}>;

const submitStoreEmail = async (
    store: Immutable<RetailStore>,
    recipient: string,
): Promise<void> => {
    const stores = [store];
    const selected = new Set([store.external_id]);
    const data: EmailSendStorePostData = {
        email: recipient,
        stores: buildStoreData(stores, selected),
    };
    await fetchJson("https://api.promosis.com/api/v1/tsi-2249/email", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
};

export const LocatorSendSingleStore = (props: IProps): React.ReactNode => {
    const [surveyOpen, setSurveyOpen] = React.useState(false);
    const [surveyEmail, setSurveyEmail] = React.useState("");

    const handleSubmit = async (recipient: string): Promise<void> => {
        await submitStoreEmail(props.store, recipient);
        setSurveyOpen(true);
        setSurveyEmail(recipient);
    };

    const handleSurveyClose = (): void => {
        setSurveyOpen(false);
    };

    return (
        <>
            <LocatorSendSingleStoreModal onSubmit={handleSubmit} />
            <LocatorSurveyModal
                isOpen={surveyOpen}
                email={surveyEmail}
                onClose={handleSurveyClose}
            />
        </>
    );
};
